import React, { createRef, ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, BoxProps, ButtonBaseActions } from '@material-ui/core';
import { ReactComponent as SuccessIcon } from 'assets/images/invite-new-user/invite-new-user-success.svg';
import FsButton from 'ui-elements/buttons/FsButton';
import FsNextArrowIcon from 'ui-elements/icons/FsNextArrow';
import FsCenterBox from 'ui-elements/common-elements/FsCenterBox/FsCenterBox';
import {
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import Routes from 'routes';
import { IconWrapperBox, WrapperBox } from './FsAlertBoard.style-elements';

interface FsAlertBoardProps extends BoxProps {
  maxWidth?: number;
  marginTop?: number;
  icon?: ReactNode;
  title: string;
  url?: Routes;
  buttonLabel?: string;
  button?: ReactNode;
}

const FsAlertBoard: React.FC<FsAlertBoardProps> = ({
  title,
  url,
  buttonLabel = 'Close',
  icon = <SuccessIcon />,
  children,
  button,
  ...boxProps
}) => {
  const actionRef = createRef<ButtonBaseActions>();

  useEffect(() => {
    if (actionRef.current) {
      actionRef.current.focusVisible();
    }
  }, [actionRef]);

  return (
    <WrapperBox {...boxProps}>
      <FsCenterBox marginBottom={4}>
        <IconWrapperBox>{icon}</IconWrapperBox>
      </FsCenterBox>
      <FsCenterBoxTitle>{title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{children}</FsCenterBoxSubTitle>
      {buttonLabel && url && (
        <Box>
          <FsButton
            component={Link}
            to={url}
            color="primary"
            variant="contained"
            endIcon={<FsNextArrowIcon />}
            autoFocus
            action={actionRef}
          >
            {buttonLabel}
          </FsButton>
        </Box>
      )}
      {button}
    </WrapperBox>
  );
};

export default FsAlertBoard;
